// src/components/Timer/SoundPlayer.js

import React, { useState, useEffect } from 'react';
import YouTube from 'react-youtube';

function SoundPlayer({
  youtubeTracks = [],
  stopCompletionSound,
}) {
  // Default fallback track
  const DEFAULT_TRACKS = [
    { name: 'Follow God', url: 'https://www.youtube.com/watch?v=ivCY3Ec4iaU' }
  ];

  // Merge default + custom, but remove any duplicates by URL
  const mergedTracks = [...DEFAULT_TRACKS, ...youtubeTracks].filter(
    (track, idx, all) => all.findIndex(t => t.url === track.url) === idx
  );

  // Current track index
  const [currentIndex, setCurrentIndex] = useState(0);

  // Keep index in range if track list changes
  useEffect(() => {
    if (currentIndex >= mergedTracks.length) {
      setCurrentIndex(0);
    }
  }, [mergedTracks.length, currentIndex]);

  // Extract YouTube ID from any URL
  const extractVideoId = url => {
    try {
      const u = new URL(url);
      return u.searchParams.get('v') || u.pathname.split('/').pop();
    } catch {
      console.error('Invalid YouTube URL:', url);
      return null;
    }
  };

  // Determine the current video ID
  const currentTrack = mergedTracks[currentIndex];
  const videoId = currentTrack && extractVideoId(currentTrack.url);
  if (!videoId) return null;

  // Handlers for Prev/Next
  const handlePrev = () => {
    setCurrentIndex(i => (i - 1 + mergedTracks.length) % mergedTracks.length);
  };
  const handleNext = () => {
    setCurrentIndex(i => (i + 1) % mergedTracks.length);
  };

  // Stop the completion sound when playback actually starts
  const onPlayerStateChange = event => {
    // 1 === playing
    if (event.data === 1 && stopCompletionSound) {
      stopCompletionSound();
    }
  };

  return (
    // key on container forces full remount when index changes
    <div key={currentIndex} className="sound-player-container">
      <div className="video-wrapper">
        <YouTube
          className="video-frame"
          videoId={videoId}
          opts={{
            width: '100%',
            height: '100%',
            playerVars: {
              autoplay: 0,
              controls: 1,
              rel: 0,
              modestbranding: 1,
            },
          }}
          onStateChange={onPlayerStateChange}
          onEnd={handleNext}
        />
      </div>
      <div className="sound-nav-buttons">
        <button onClick={handlePrev} disabled={mergedTracks.length < 2}>
          Prev
        </button>
        <button onClick={handleNext} disabled={mergedTracks.length < 2}>
          Next
        </button>
      </div>
    </div>
  );
}

export default SoundPlayer;
